import { render } from "./form-text.vue?vue&type=template&id=7ef27322"
import script from "./form-text.vue?vue&type=script&lang=js"
export * from "./form-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__